import React from "react";
import banner from "../Images/Common/Banner.png";

const Banner = ({ name, Title }) => {
  return (
    <div className="relative h-40 md:h-96 w-full overflow-hidden">
      {/* Background Image with overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${banner})`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-start px-6 md:px-16">
        <div>
          <h1 className="text-3xl md:text-5xl font-bold text-white">{Title}</h1>
          <div className="mt-3 h-1 w-16 bg-Orange rounded"></div>
          <nav className="mt-4 text-white text-sm md:text-base">
            <a href="/" className="hover:underline">
              Home
            </a>
            <span className="mx-2">{">"}</span>
            <span className="text-gray-300">{name}</span>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Banner;
